import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import { ServiceSubModules } from 'utils/enum/ServiceInvoiceEnum';

export default class ServiceUtils {
    static getIndexFromList = (list, selected) => {
        const tabIndex = list.indexOf(selected);
        if (tabIndex !== -1) return tabIndex;

        return 0;
    };

    static getSubModuleList = () => {
        const subModules = [];
        const keyStore = new KeyStore();

        const SERVICE_READ = keyStore.hasPermission(Permission.SERVICE_READ);
        const OPERATION_CODE_READ = keyStore.hasPermission(Permission.SERVICE_OPERATION_CODE_READ);
        const OPERATION_CODE_EDIT = keyStore.hasPermission(Permission.SERVICE_OPERATION_CODE_EDIT);

        if (SERVICE_READ) subModules.push(ServiceSubModules.REPAIRS_ORDERS);
        if (SERVICE_READ) subModules.push(ServiceSubModules.TECHNICIAN_JOB_LIST);
        if (OPERATION_CODE_READ || OPERATION_CODE_EDIT) subModules.push(ServiceSubModules.OPERATION_CODES);
        if (SERVICE_READ) subModules.push(ServiceSubModules.APPOINTMENTS);

        return subModules;
    };
}
